<svg [attr.width]="width" [attr.height]="height" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M283.33 283.333L366.663 200L283.33 116.667M116.663 116.667L33.3301 200L116.663 283.333M233.33 50L166.663 350"
    stroke="var(--stroke-color)"
    stroke-width="33.3333"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
